export default "__VITE_ASSET__DfhlgZdW__"